'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _nth2 = require('lodash/nth');

var _nth3 = _interopRequireDefault(_nth2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _flatten2 = require('lodash/flatten');

var _flatten3 = _interopRequireDefault(_flatten2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _computors = require('../utils/computors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    data: function data(_data) {
      return (0, _filter3.default)((0, _flatten3.default)((0, _map3.default)(target.accessors.data(_data), function (serie) {
        return (0, _map3.default)(serie.values, function (value) {
          return {
            x: value,
            y: (0, _get3.default)(serie, 'category', ''),
            baselineIndex: (0, _get3.default)(serie, 'baselineIndex', -1),
            highlightIndex: (0, _get3.default)(serie, 'highlightIndex', -1)
          };
        });
      })), function (d) {
        return d.x !== null;
      });
    },
    computeOrdinalFocus: function computeOrdinalFocus(data) {
      return (0, _map3.default)(target.accessors.data(data), function (datapoint) {
        return {
          baselineIndex: (0, _get3.default)(datapoint, 'baselineIndex', -1),
          highlightIndex: (0, _get3.default)(datapoint, 'highlightIndex', -1)
        };
      });
    },
    computeMarkers: function computeMarkers(symbolValues) {
      return function (datum) {
        return (0, _filter3.default)((0, _map3.default)(datum.values, function (v, i) {
          return {
            baselineIndex: (0, _get3.default)(datum, 'baselineIndex', -1),
            highlightIndex: (0, _get3.default)(datum, 'highlightIndex', -1),
            formatedValue: (0, _nth3.default)((0, _get3.default)(datum, 'formatedValues', []), i),
            x: v,
            y: datum.category,
            marker: i,
            symbolValue: (0, _get3.default)(symbolValues, '[' + i + ']', '')
          };
        }), function (d) {
          return d.x !== null;
        });
      };
    },
    yValues: function yValues(data) {
      return (0, _map3.default)(target.accessors.data(data), target.accessors.y);
    },
    yScale: function yScale(options, data, offset) {
      return (0, _computors.computeOrdinalScale)(options.axis.y.ordinal, target.computors.yRange(options, offset), target.computors.yValues(data));
    },
    yAxis: function yAxis(scale, pivot, options) {
      return (0, _computors.computeOrdinalAxis)(scale, options);
    }
  });
}
exports.default = computors;